/**
 * api sdk
 */

import axios from 'axios';
import qs from 'qs';
import AppNative from '@/assets/utils/AppNative';
import CacheUtil from '@/assets/utils/CacheUtil';
import Vue from 'vue';

import Cookies from 'js-cookie';

import { Loading } from 'element-ui';
import { Message } from 'element-ui';

import { MessageBox } from 'element-ui';
import { Dialog } from 'vant';

// 发送请求前配置请求及参数 
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

axios.interceptors.request.use(_request => {
  _request.headers["X-Requested-With"] = "AJAX#17";

  _request.headers["taojintoken"] = _getUserToken();

  if(_request.method === 'post') {
    if ( _request.url == '//upload-z0.qiniup.com' ) {
      return _request;
    }

    if( _request.url.match(new RegExp('^.*/json/.*$')) ) { 
      return _request;
    }

    if ( !_request.data ) {
     _request.data = {};
    }

    _request.data = qs.stringify(_request.data,{
      allowDots:true
    });
  }

 return _request;
}, error => {
  console.log("#63 interceptors.request error",error);
  _.toast("错误的传参", 'fail');
  return Promise.reject(error);
});

var _confirm = function( _message, _onYes ) {
  if ( AppNative.isMobile() ) {
    Dialog.confirm({ message: _message }).then(_onYes);
  } else {
    MessageBox.confirm(_message).then(_onYes);
  }
};

var _alert = function( _message ) {
  if ( AppNative.isMobile() ) {
    // Dialog.alert({ message: _message });
    alert(_message)
  } else {
    MessageBox.alert(_message);
  }
};

window._confirm = _confirm;

window._alert = _alert;

window._message = function( _txt ) {
  // console.log('#175 _message', _txt);

  Message({
    type : 'success',
    message : _txt,
    offset : 150,
    showClose : true
  });
};

window._notify = function( _txt ) {
  console.log('#187 _notify', _txt);

  Message({
    type : 'success',
    message : _txt,
    offset : 10,
    showClose : true,
    center : true
  });
};


axios.interceptors.response.use((res) => {
  if( ( !!res.data.status && res.data.status == 1103 ) || ( !res.data.status && res.data.data == 201 ) ) {
    _confirm('去登陆? [55]', () => { // 跳转前确认
      localStorage.setItem('ticket.UrlBeforeLogin.href', location.href); // 登陆前地址
      location.href = API_ROOT.systemHeader + '/ticket/sso/authorize?62';
    });
  }

  return res;
},(error) =>{
  console.log("#74 interceptors.response error",error);
  _.toast("网络异常", 'fail')
  return Promise.reject(error)
});


window.$ = $;


// 检查
if(!window.BudoDubboHttpApiJavascriptSdk) {
  $("#app").html("<h1>ERROR #155 no BudoDubboHttpApiJavascriptSdk</h1>");
  throw "#156 no BudoDubboHttpApiJavascriptSdk";
}


window.sdk = new BudoDubboHttpApiJavascriptSdk();
window.sdk.setUrl("/ticket/api");

var getUserToken = function() {
  if ( self != top ) { // 当前工单页面是否通过 iframe 嵌套
    // iframe 本次通过 _cookie/token 明确传入的 token 应优先于历史缓存。
    var runtimeTokenFromUrl = CacheUtil.getRuntimeTokenFromUrl();
    if( !!runtimeTokenFromUrl && runtimeTokenFromUrl != '' ) {
      return runtimeTokenFromUrl;
    }

    if ( CacheUtil.getMerchantToken() ) {
      return CacheUtil.getMerchantToken();
    }
  }

  // 苹果
  var mobileToken = CacheUtil.getLocalStorageToken();
  if( !!mobileToken && mobileToken != '' ) {
    return mobileToken;
  }

  // 安卓
  var androidToken = AppNative.getAndroidToken();
  if( !!androidToken && androidToken != '' ) {
    return androidToken;
  }

  // @see auth.js
  var login_token = Cookies.get('login_token');
  if( !!login_token && login_token != '' ) {
    return login_token;
  }

  var system_token = Cookies.get('system_token');
  if( !!system_token && system_token != '' ) {
    return system_token;
  }

  // TokenFromUrl
  var mobileTokenFromUrl = CacheUtil.getLocalStorageTokenFromUrl();
  return mobileTokenFromUrl;
};


window._getUserToken = getUserToken;

let _loadingCount = 0;


window.sdk.setRequestFilter(function(_request) {
  if ( !window._doNotShowLoading ) {
    _loadingCount += 1;

    _request['_loading'] = Loading.service({
      customClass : '_loading_custom_class_' + _loadingCount,
      text: _request.interfaceName + '.' + _request.methodName + ' 加载中 ...', 
      background: 'rgba(0, 0, 0, 0)'
    });
  }

  _request.parameters["_token"] = _getUserToken();
  return _request;
});


window.sdk.setResponseHandler(function(_request) {
  if ( !!_request['_loading'] ) {
      _loadingCount -= 1;
      _request['_loading'].close();
  }

  // 有 error
  if( !!_request.error ) {
    if ( "forbid_access_error" == _request.error.error ) {
      _message('#161' + JSON.stringify(_request.error));
      return;
    }

    _request.callback.fail(_request.error.error_description, _request);
    return;
  }

  var _responseBody = _request.responseBody;
  var _responseEntity =  _request.serialization.deserialize(_responseBody);

  // 正常
  if ( "0" == _responseEntity.status + "" ) { // 数字 0 为 false
    _request.callback.success(_responseEntity.result, _request);
    return;
  }

  // 未登录
  if( _responseEntity.status == 1103 || _responseEntity.status == 1102 ) { // 未登录
    _responseEntity.result.status = _responseEntity.status;
    _request.callback.fail(_responseEntity.result, _request);
    return;
  }

 // 其他错误回调
  _request.callback.fail(_responseEntity.result.error_description, _request);
});


window.sdk.setCallback({
  success : ( _responseEntity, _request ) => {
    console.log('#147 success', _responseEntity, _request);
  },

  fail : ( _error, _request ) => { // 默认错误处理
    // 其他错误默认处理
    console.log('#150 fail, _error=', _error, ', _request=', _request);

    if( _error && ( _error.status == 1103 || _error.status == 1102 ) ) { // 未登录
      _confirm('#175 去登陆?', () => { // 跳转前确认
        localStorage.setItem('ticket.UrlBeforeLogin.href', location.href); // 登陆前地址
        if(window.location.href.indexOf('feige') > 0) {
          location.href = '/ticket/sso/authorize?authorize_type=TjkMerchantUser';
        }else {
          location.href = '/ticket-vue/login?177';
        }
      });

      return;
    }

    _message('#151 callback fail _error = ' + JSON.stringify(_error) // 
      + ', responseBody = ' + JSON.stringify(_request.responseBody) // 
      + ', api = ' + _request.interfaceName + "." + _request.methodName);
  }
});

window.sdk.setCacheManager({
  get(_request) {
      var _key = "budo-cache" + _request.url + _request.interfaceName + "." + _request.methodName // 
          + "(" + JSON.stringify(_request.headers) + "," + JSON.stringify(_request.args) + "," + JSON.stringify(_request.parameters) + ")";
      return storage.fetch(_key);
  },

  put(_request) {
      var _key = "budo-cache" + _request.url + _request.interfaceName + "." + _request.methodName // 
          + "(" + JSON.stringify(_request.headers) + "," + JSON.stringify(_request.args) + "," + JSON.stringify(_request.parameters) + ")";
      storage.persist(_key, _request.responseBody);
  }
});


Vue.prototype.$http = axios;



// WEBPACK FOOTER //
// ./src/assets/sdk.js